const React = require("react");
const PropTypes = require("prop-types");

const Title = ({ children }) => <h2 className="pane__title">{children}</h2>;

Title.propTypes = {
  children: PropTypes.node.isRequired,
};

module.exports = Title;
